export default {
    buildings: [

        // Casas
        { src: 'buildings/Constructed_FenceWood-0.png', shape: [1,1] },
        { src: 'buildings/Constructed_House01-0.png' },
        { src: 'buildings/Constructed_House03-0.png' },
        { src: 'buildings/Constructed_House04-0.png' },
        { src: 'buildings/Constructed_House05-0.png' },
        
        { src: 'buildings/Constructed_House08-0.png' },
        { src: 'buildings/Constructed_HouseMushroom01-0.png' },
        { src: 'buildings/Constructed_HouseMushroom03-0.png' },
        { src: 'buildings/Constructed_HouseMushroom05-0.png' },
        { src: 'buildings/House_A-0.png' },
        { src: 'buildings/bld-01-0.png', size: 2 },
        { src: 'buildings/bld-02-0.png', size: 2 },
        { src: 'buildings/bld-03-0.png', size: 2 },
        { src: 'buildings/bld-05-0.png', size: 2 },
        { src: 'buildings/bld-06-0.png', size: 2 },
        { src: 'buildings/bld-08-0.png', size: 2 },
        { src: 'buildings/bld-09-0.png', size: 2 },
        
        { src: 'buildings/house_01-0.png' },
        { src: 'buildings/house_02-0.png' },
        { src: 'buildings/house_03-0.png' },
        { src: 'buildings/house_04-0.png' },
        { src: 'buildings/house_05-0.png' },
        { src: 'buildings/house_06-0.png' },
        { src: 'buildings/house_07-0.png' },
        { src: 'buildings/house_08-0.png' },
        { src: 'buildings/house_09-0.png' },
        { src: 'buildings/house_10-0.png' },
        { src: 'buildings/house_11-0.png' },
        { src: 'buildings/house_12-0.png' },
        { src: 'buildings/house_13-0.png' },
        { src: 'buildings/house_14-0.png' },
        { src: 'buildings/house_15-0.png' },
        { src: 'buildings/house_16-0.png' },
        { src: 'buildings/house_18-0.png' },
        { src: 'buildings/house_19-0.png' },
        { src: 'buildings/house_20-0.png' },
        { src: 'buildings/house_21-0.png' },
        { src: 'buildings/house_22-0.png' },
        { src: 'buildings/house_23-0.png' },
        { src: 'buildings/house_24-0.png' },
        { src: 'buildings/house_25-0.png' },
        { src: 'buildings/house_26-0.png' },
        { src: 'buildings/house_27-0.png' },
        { src: 'buildings/house_28-0.png' },
        { src: 'buildings/house_29-0.png' },
        { src: 'buildings/house_30-0.png' },
        { src: 'buildings/house_31-0.png' },
        { src: 'buildings/house_32-0.png' },
        { src: 'buildings/house_33-0.png' },
        { src: 'buildings/house_34-0.png' },
        { src: 'buildings/house_36-0.png' },
        { src: 'buildings/house_37-0.png' },
        { src: 'buildings/house_38-0.png' },
        { src: 'buildings/house_39-0.png' },
        { src: 'buildings/house_40-0.png' },
        { src: 'buildings/house_41-0.png' },
        { src: 'buildings/house_44-0.png' },
        { src: 'buildings/house_47-0.png' },
        { src: 'buildings/House_08_F-0.png' },
        { src: 'buildings/House_09_F-0.png' },
        { src: 'buildings/House_10_F-0.png' },
        
        // Other buildings
        { src: 'buildings/Circus-0.png' },
        { src: 'buildings/bld-10-0.png', size: 3 },
        { src: 'buildings/Market_01-0.png' },
        { src: 'buildings/Market_02-0.png' },
        { src: 'buildings/shop_03-0.png' },
        { src: 'buildings/scene-0.png' },
        { src: 'buildings/shop_01-0.png', size: 2 },
        { src: 'buildings/shop_04-0.png', size: 2 },
        { src: 'buildings/shop_05-0.png' },
        { src: 'buildings/shop_06-0.png' },
        { src: 'buildings/shop_07-0.png' },
        { src: 'buildings/shop_85-0.png' },
        { src: 'buildings/shop_92-0.png' },
        { src: 'buildings/Egg_House_01-0.png' },
        
        // Torres
        { src: 'buildings/Constructed_HouseMushroom07-0.png' },
        { src: 'buildings/Constructed_Tower01-0.png' },
        { src: 'buildings/Constructed_Tower02-0.png' },
        { src: 'buildings/Constructed_Tower03-0.png' },
        { src: 'buildings/Constructed_Tower03_Simple-0.png' },
        { src: 'buildings/Constructed_Tower04-0.png' },
        { src: 'buildings/Constructed_WallStone04-0.png' },
        { src: 'buildings/WoodenLadder-0.png' },
        { src: 'buildings/wind_mill-0.png' },
        { src: 'buildings/wind_mill01-0.png' },
        { src: 'buildings/wind_mill02-0.png' },
        { src: 'buildings/wind_mill03-0.png' },
        { src: 'buildings/ConstructedLighthouseTower-0.png' },
        { src: 'buildings/Constructed_BridgeWood01-0.png' },
        
        // Doors
        { src: 'buildings/Door_01-0.png', size: 2 },
        { src: 'buildings/Door_02-0.png', size: 2 },
        { src: 'buildings/Easter_Gate_F-0.png', size: 2 },
        { src: 'buildings/house_door_01-0.png', size: 1 },
        { src: 'buildings/house_door_02-0.png', size: 2 },
        { src: 'buildings/house_door_03-0.png', size: 3 },
        { src: 'buildings/house_door_04-0.png', size: 1 },
        { src: 'buildings/house_door_05-0.png', size: 2 },
        { src: 'buildings/house_door_06-0.png', size: 3 },
        { src: 'buildings/house_door_08-0.png', size: 1 },
        { src: 'buildings/house_door_09-0.png', size: 2 },
        { src: 'buildings/house_door_10-0.png', size: 3 },

        // Bridges
        { src: 'buildings/bridge-01_-0.png', size: 2 },
        { src: 'buildings/bridge_01-0.png', size: 2 },
        { src: 'buildings/bridge_02-0.png', size: 2 },
        { src: 'buildings/bridge_03-0.png', size: 2 },
        { src: 'buildings/bridge_big_01-0.png', size: 2 },
        { src: 'buildings/bridge_big_02-0.png', size: 2 },

        // Sillas/Bancos
        { src: 'buildings/bench_-0.png', size: 1 },
        { src: 'buildings/bench_02-0.png', size: 1 },
        { src: 'buildings/bench_04-0.png', size: 1 },
        { src: 'buildings/bench_05-0.png', size: 1 },
        { src: 'buildings/bench_06-0.png', size: 1, space: [1,1] },
        { src: 'buildings/bench_07-0.png', size: 1 },
        { src: 'buildings/bench_08-0.png', size: 1 },
        { src: 'buildings/Chair-0.png', size: 1 },

        // Barcos
        { src: 'buildings/Galleon-0.png', class: 'sailing' },
        { src: 'buildings/Galleon_Flying-0.png', class: 'sailing' },
        { src: 'buildings/Sloop-0.png', class: 'sailing' },
        { src: 'buildings/Sloop_Flying-0.png', class: 'sailing'},
        { src: 'buildings/Glider-0.png', size: 2, class: 'floating' },
        { src: 'buildings/Balloon_01-0.png', class: 'floating' },
        { src: 'buildings/Balloon_02_F-0.png', class: 'floating' },
        

        // Otros
        { src: 'buildings/Barrel_01-0.png', size: 1 },
        { src: 'buildings/Barrel_02-0.png', size: 1 },
        { src: 'buildings/Bird_Net-0.png', size: 2 },
        { src: 'buildings/Board_Guide-0.png', size: 1 },
        { src: 'buildings/Cannon-0.png', size: 1 },
        { src: 'buildings/Cart-0.png', size:2  },
        { src: 'buildings/Chest_01-0.png', size: 1 },
        { src: 'buildings/Chest_02-0.png', size: 1 },

        { src: 'buildings/ConstructedPropellerTower-0.png', size: 2 },
        { src: 'buildings/EasterEgg_Group-0.png' },
        { src: 'buildings/Egg_Basket-0.png', size: 1 },
        { src: 'buildings/Egg_Basket_01-0.png', size: 1 },
        { src: 'buildings/Egg_Tree_01-0.png', size: 2 },
        { src: 'buildings/Flag-0.png', size: 1 },
        { src: 'buildings/Fountain-0.png', size: 2 },
        { src: 'buildings/Light-pole_-0.png', size: 2 },
        { src: 'buildings/ROYAL_EGG-0.png', size: 2 },
        { src: 'buildings/TowerDefence_Wall-0.png', size: 1 },
        { src: 'buildings/WheelCrane-0.png', size: 2 },
        { src: 'buildings/WheelWater-0.png', size: 2 },


        // Poligonos
        { src: 'buildings/ConeSmooth-0.png', size: 1 },
        { src: 'buildings/ConeSmooth-Cutout-0.png', size: 1 },
        { src: 'buildings/Dodecahedron-0.png', size: 1 },
        { src: 'buildings/Domo-0.png', size: 1 },
        { src: 'buildings/Hexagonal-prism-0.png', size: 1 },
        { src: 'buildings/Platform-Pyramid-0.png', size: 1 },
        { src: 'buildings/Sphere-0.png', size: 1 },
        { src: 'buildings/Torus-0.png', size: 1 },
        
    ],
    nature: [
        
        // Trees
        { src: 'nature/obj1-0.png', size: 2 },
        { src: 'nature/obj2-0.png', size: 2 },
        { src: 'nature/obj4-0.png', size: 2 },
        { src: 'nature/obj5-0.png', size: 2 },
        { src: 'nature/obj6-0.png', size: 2 },
        { src: 'nature/obj8-0.png', size: 2 },
        { src: 'nature/Egg_Tree_02a-0.png', size: 2 },
        { src: 'nature/tree_01-0.png', size: 2 },
        { src: 'nature/tree_06-0.png', size: 2 },
        { src: 'nature/tree_07-0.png', size: 2 },
        { src: 'nature/tree_08-0.png', size: 2 },
        { src: 'nature/tree_09-0.png', size: 2 },
        { src: 'nature/tree_88-0.png', size: 2 },
        { src: 'nature/tree_89-0.png', size: 2 },
        { src: 'nature/tree_90-0.png', size: 2 },
        { src: 'nature/tree_91-0.png', size: 2 },
        { src: 'nature/tree_92-0.png', size: 2 },
        { src: 'nature/tree_94-0.png', size: 2 },
        { src: 'nature/tree_95-0.png', size: 2 },
        { src: 'nature/tree_96-0.png', size: 2 },

        // Troncos
        { src: 'nature/Constructed_BridgeWood02-0.png', size: 1 },
        { src: 'nature/FenceLog_Pole-0.png', size: 1 },
        { src: 'nature/Fireplace-0.png', size: 1 },
        { src: 'nature/PoleArrow_01-0.png', size: 1 },
        { src: 'nature/PoleArrow_02-0.png', size: 1 },
        { src: 'nature/TreeLogs-0.png', size: 2 },
        { src: 'nature/TreeStump-0.png', size: 2 },
        { src: 'nature/bld-04-0.png', size: 2 },
        { src: 'nature/tree_02-0.png', size: 2 },
        { src: 'nature/tree_03-0.png', size: 2 },
        { src: 'nature/tree_04-0.png', size: 2 },
        { src: 'nature/tree_05-0.png', size: 2 },

        // Cactuses
        { src: 'nature/cactus_01-0.png', size: 2 },
        { src: 'nature/cactus_02-0.png', size: 2 },
        { src: 'nature/cactus_03-0.png', size: 2 },
        
        // Cristales
        { src: 'nature/BushRounded_04-0.png', size: 2 },
        { src: 'nature/CrystalGroup_02-0.png',size: 2 },
        { src: 'nature/Crystal_02-0.png', size: 2 },

        // Other
        { src: 'nature/Buicay-0.png', size: 2 },
        { src: 'nature/Carrot-0.png', size: 2 },
        { src: 'nature/Daffodil_Field-0.png', size: 2 },
        { src: 'nature/Grass_04-0.png', size: 1 },
        { src: 'nature/Haystack_01-0.png', size: 1 },
        { src: 'nature/Haystack_02-0.png', size: 1 },
        { src: 'nature/Melon_Field1-0.png', size: 2 },
        { src: 'nature/Melon_Field2-0.png', size: 2 },
        { src: 'nature/Mother_Tree-0.png', size: 2 },
        { src: 'nature/Mushrooms_01-0.png', size: 2 },
        { src: 'nature/Mushrooms_02-0.png', size: 2 },
        { src: 'nature/HouseMushroom-0.png', size: 2 },
        
        // Rocas
        { src: 'nature/Rock_07-0.png', size: 2 },
        { src: 'nature/rock_08-0.png', size: 2 },
        { src: 'nature/rock_09-0.png', size: 2 },
        { src: 'nature/bld-07-0.png', size: 2 },
        { src: 'nature/Rock_Group-0.png', size: 2 },
        { src: 'nature/Stone_01-0.png', size: 2 },

        
        // Other
        { src: 'nature/Tulip_Pots-0.png', size: 2 },
        { src: 'nature/fern_01-0.png', size: 2 },
        { src: 'nature/fern_02-0.png', size: 2 },
        { src: 'nature/fern_03-0.png', size: 2 },
        { src: 'nature/fern_04-0.png', size: 2 },
        { src: 'nature/flower_01-0.png', size: 2 },
        { src: 'nature/flower_02-0.png', size: 2 },
        { src: 'nature/flower_garden-0.png', size: 2 },
        { src: 'nature/palmmm_01-0.png', size: 1 },
        { src: 'nature/palmmm_02-0.png', size: 1 },
        { src: 'nature/plant_08-0.png', size: 2 },
        { src: 'nature/plant_09-0.png', size: 2 },
        { src: 'nature/plant_10-0.png', size: 2 },
        { src: 'nature/plant_11-0.png', size: 1 },
        { src: 'nature/plant_12-0.png', size: 1 },
        { src: 'nature/plant_18-0.png', size: 1 },
        { src: 'nature/Carrot_field-0.png', size: 2 },

        // New
        { src: 'nature/plant_01_01-0.png' },
        { src: 'nature/plant_01_02-0.png' },
        { src: 'nature/plant_01_03-0.png' },
        { src: 'nature/plant_01_04-0.png' },
        { src: 'nature/plant_01_05-0.png' },
        { src: 'nature/plant_02_01-0.png' },
        { src: 'nature/plant_02_02-0.png' },
        { src: 'nature/plant_02_03-0.png' },
        { src: 'nature/plant_02_04-0.png' },
        { src: 'nature/plant_03_01-0.png' },
        { src: 'nature/plant_03_02-0.png' },
        { src: 'nature/plant_03_03-0.png' },
        { src: 'nature/plant_03_04-0.png' },
        { src: 'nature/plant_04_01-0.png' },
        { src: 'nature/plant_04_02-0.png' },
        { src: 'nature/plant_04_03-0.png' },
        { src: 'nature/plant_04_04-0.png' },
        { src: 'nature/plant_04_05-0.png' },
        { src: 'nature/plant_06_01-0.png' },
        { src: 'nature/plant_06_02-0.png' },
        { src: 'nature/plant_06_03-0.png' },
        { src: 'nature/plant_06_04-0.png' },
        { src: 'nature/plant_07_01-0.png' },
        { src: 'nature/plant_07_02-0.png' },
        { src: 'nature/plant_07_03-0.png' },
        { src: 'nature/plant_07_04-0.png' },
    ],
    characters: [
        { src: 'characters/Obj1-0.png', size: 2 },
        { src: 'characters/Obj2-0.png', size: 2 },
        { src: 'characters/Obj3-0.png', size: 2 },
        { src: 'characters/Obj4-0.png', size: 2 },
        { src: 'characters/Obj5-0.png', size: 2 },
        { src: 'characters/Obj6-0.png', size: 2 },
        { src: 'characters/Obj7-0.png', size: 2 },
        { src: 'characters/Obj8-0.png', size: 2 },
        { src: 'characters/Obj9-0.png', size: 2 },
        { src: 'characters/Bunny_Husband-0.png', size: 2 },
        { src: 'characters/Bunny_Wife-0.png', size: 2 },
        { src: 'characters/dino1_blender-0.png', size: 2 },
        { src: 'characters/dino2_blender-0.png', size: 2 },
        { src: 'characters/dino3_blender-0.png', size: 2 },
        { src: 'characters/drago_anim_blender-0.png', size: 2 },
        { src: 'characters/drago_anim_middle_blender-0.png', size: 2 },
        { src: 'characters/drago_anim_small_blender-0.png', size: 2 },
        { src: 'characters/yeti_blender1-0.png', size: 2 },
        { src: 'characters/yeti_blender2-0.png', size: 2 },
        { src: 'characters/yeti_blender3-0.png', size: 2 },

        { src: 'characters/c_bot_08_blender-0.png', size: 2 },
        { src: 'characters/c_bot_15_blender-0.png', size: 2 },
        { src: 'characters/c_bot_20_blender-0.png', size: 2 },
        
    ]
}



// WEBPACK FOOTER //
// ./src/Resources.js